import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=529c3e0c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('529c3e0c')) {
      api.createRecord('529c3e0c', component.options)
    } else {
      api.reload('529c3e0c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=529c3e0c&", function () {
      api.rerender('529c3e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27UopW193o4ot/JS/comp/childrenage.vue"
export default component.exports